<template>
    <div id="teams" class="tabcontent tabcontent-border-style">
        <div class="fullInputs mb-4">
            <div class="twoInputs">
                <div class="btnInsideInput">
                    <input type="text" id="free_search" class="form-control" v-model="search"
                           placeholder="Search" @input="searchHandler" maxlength="50">
                    <button @click="searchBackEndHandler">
                        <img src="../../../assets/images/SearchIcon.png" alt="">
                    </button>
                </div>
            </div>
            <div class="oneInput">
                <select id="filter_dates" class="form-select" v-model="sort" @change="getTeams">
                    <option selected disabled value="">Sort by Date</option>
                    <option value="asc">Oldest</option>
                    <option value="desc">Latest</option>
                </select>
            </div>
        </div>
        <div class="table-container" v-if="teams.length > 0">


            <TableComponent :thead="thead" :tbody="teams" @update="updateTeam" @sort="SortTeam" :keys="keys"
                            model="teams" name="entity"
                            updateUrl="/settings/teams/edit"/>

            <div class="paginationLink">
                <pagination :data="laravelData" @pagination-change-page="getTeams" :limit="3">
                    <template #prev-nav>
                        <span>Previous</span>
                    </template>
                    <template #next-nav>
                        <span>Next</span>
                    </template>
                </pagination>
            </div>
        </div>

        <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
            <div class="h3Organization">
                <h3 v-if="!isSearch">You Don't Have Any Teams Yet</h3>
                <h3 v-else>No Data</h3>
            </div>
            <router-link class="text-decoration-none btn-container  btn-container-no-data"
                         v-if="permissions.includes('create team') && teams.length === 0 && !isSearch"
                         to="/settings/teams/create">
                <span>Create Team</span>
            </router-link>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import team from "../../../api-services/team";

    export default {
        name: 'setting-team',
        data() {
            return {
                thead: ['Team Name', 'Number of Users', 'Leader'],
                keys: ['name', 'users_count' , 'user'],
                permissions: [],
                teams: [],
                filteredArray: [],
                originalTeams: [],
                laravelData: {},
                error: null,
                search: '',
                sort: 'desc',
                state: false,
                isSearch: false
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'settings');
            this.permissions = this.$store.state.auth.permissions;
            await this.getTeams();
        },
        methods: {
            async getTeams (page = 1) {
                try {
                    const response = await team.index(this.search, this.sort !== '' ? this.sort : 'desc' ,true, 1, true);

                    response.data.teams.data.forEach((team)  => {
                        team['delateFlag'] = team.users_count > 0
                    });
                    let filteredTeams = response.data.teams.data.filter(function(data){
                        return data.users_count != 0;
                    });
                    this.teams = filteredTeams;
                    // this.teams = response.data.teams.data;
                    // this.teams = response.data.teams.data;

                    if(this.teams.length > 0){
                        this.$emit('data-event', {'team': {action:true, search: this.isSearch}});
                    }else{
                        this.$emit('data-event', {'team': {action:false, search: this.isSearch}});

                    }

                    // console.log(this.teams.length)

                    // console.log(response);
                    this.laravelData = response.data.teams;
                    this.originalTeams = response.data.teams.data;

                } catch (e) {
                    // console.log(e);
                    this.error = e;
                }
            },
            updateTeam(e) {
                let filteredData = this.teams.filter(function (data) {
                    return data.id != e;
                });
                this.teams = filteredData;
            },
            searchHandler(e) {
                this.isSearch = true;
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                //
                // if (serachedValue !== '') {
                //     this.isSearch = true;
                // } else {
                //     this.isSearch = false;
                // }
                // searchedData = this.originalTeams.filter((data) => data.name.toLowerCase().indexOf(serachedValue) >= 0);
                // this.teams = searchedData;
            },

            async searchBackEndHandler (searchFlag = true) {
                await this.getTeams(searchFlag);
            },
            SortTeam() {
                let status = !this.state;
                this.originalTeams.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            },
            filterHandler(e) {
                let filterType = e.target.value;
                if (filterType === 'asc') {
                    this.teams.sort(function (a, b) {
                        return new Date(a.created_at) - new Date(b.created_at);
                    });
                } else {
                    this.teams.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });
                }
            }
        }
    }
</script>

<style scoped>
    /*.btnInsideInput {*/
    /*    display: flex;*/
    /*    flex-direction: row;*/
    /*    border: 1px solid #39525C;*/
    /*    border-radius: 3px;*/
    /*    position: relative;*/
    /*}*/

    /*.btnInsideInput button {*/
    /*    position: absolute;*/
    /*    right: 0;*/
    /*    top: 10%;*/
    /*    background-color: #032431;*/
    /*    border: none;*/
    /*}*/

    /*.btnInsideInput input {*/
    /*    border: none;*/
    /*}*/

    /*.twoInputs #free_search {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 250px;*/
    /*}*/

    /*.twoInputs #filter {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 250px;*/
    /*}*/

    /*.oneInput #filter_dates {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 250px;*/
    /*}*/

    /*.twoInputs {*/
    /*    display: flex;*/
    /*    flex-direction: row;*/
    /*    gap: 20px;*/
    /*}*/

    /*.fullInputs {*/
    /*    justify-content: space-between;*/
    /*    display: flex;*/
    /*}*/
</style>


